import { render, staticRenderFns } from "./UserAccessPanel.vue?vue&type=template&id=6936ab56&scoped=true&"
import script from "./UserAccessPanel.vue?vue&type=script&lang=js&"
export * from "./UserAccessPanel.vue?vue&type=script&lang=js&"
import style0 from "./UserAccessPanel.vue?vue&type=style&index=0&id=6936ab56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936ab56",
  null
  
)

export default component.exports